module.exports = __webpack_public_path__ + "img/saida.f263ba5e.svg";